"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
class ContentStore {
    constructor() {
        this.modulesList = [];
        this.modulesExtraList = [];
        this.loaded = false;
        this.loadedExtra = false;
        this.allModulesLoadedPages = false;
        this.allModulesExtraLoadedPages = false;
        this.lastEditedModule = null;
        this.lastCreatedModule = null;
        this.lastLoadedProductId = null;
        this.search = '';
        this.bulkDrippingInProgress = false;
    }
    get isReorderingModulesEnabled() {
        return !this.search;
    }
}
__decorate([
    mobx_1.observable
], ContentStore.prototype, "modulesList", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "modulesExtraList", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "loaded", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "loadedExtra", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "allModulesLoadedPages", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "allModulesExtraLoadedPages", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "lastEditedModule", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "lastCreatedModule", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "lastLoadedProductId", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "search", void 0);
__decorate([
    mobx_1.observable
], ContentStore.prototype, "bulkDrippingInProgress", void 0);
__decorate([
    mobx_1.computed
], ContentStore.prototype, "isReorderingModulesEnabled", null);
exports.default = new ContentStore();
